import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { router } from 'modules/common/utils';
import { Icon, DropdownToggle } from 'modules/common/components';
import { PerPageButton, Option } from './styles';
import { Dropdown } from 'react-bootstrap';

// per page chooser component
const ReportPerPageChooser = ({ history, perPage, onPerPageChooser }, { __ }) => {
  const currentPerPage = perPage;

  const onClick = perPage => {
    onPerPageChooser(perPage);
  };

  const renderOption = number => {
    return (
      <Option>
        <a onClick={() => onClick(number)}>{number}</a>
      </Option>
    );
  };

  return (
    <Dropdown id="per-page-chooser" className="dropup">
      <DropdownToggle bsRole="toggle">
        <PerPageButton>
          {currentPerPage} {__('per page')} <Icon icon="uparrow-2" />
        </PerPageButton>
      </DropdownToggle>
      <Dropdown.Menu>
        {renderOption(10)}
        {renderOption(20)}
        {renderOption(30)}
        {renderOption(50)}
        {renderOption(100)}
        {renderOption(200)}
      </Dropdown.Menu>
    </Dropdown>
  );
};

ReportPerPageChooser.propTypes = {
  history: PropTypes.object.isRequired
};

ReportPerPageChooser.contextTypes = {
  __: PropTypes.func
};

export default withRouter(ReportPerPageChooser);



// WEBPACK FOOTER //
// src/modules/common/components/reportPagination/ReportPerPageChooser.js